import * as React from 'react';
import { Flex, FlexDirection } from 'src/components/Flex/Flex';
import { Color, ResponsiveSize } from 'src/components/Globals/Globals';
import { IOptionInterface } from 'src/components/MultiSelectFilter/IOptionInterface';
import { MultiSelectFilterOption } from 'src/components/MultiSelectFilter/MultiSelectFilterOption';
import * as ReactTooltip from 'react-tooltip';

interface IMultiSelectFilterInterface {
  options: IOptionInterface[];
  filterFunction: any;
  selectedColor?: Color;
}

export class MultiSelectFilter extends React.Component<IMultiSelectFilterInterface, any> {
  public render() {
    const options = this.props.options.map((option: IOptionInterface) => {
      return (
        <MultiSelectFilterOption
          key={'select-option ' + option.id}
          id={option.id}
          label={option.label}
          selected={option.selected}
          selectedColor={this.props.selectedColor}
          helpText={option.helpText}
          onClick={element => {
            option.selected = !option.selected;
            this.props.filterFunction();
          }}
        />
      );
    });

    return (
      <Flex direction={FlexDirection.column} tileAfter={ResponsiveSize.tablet}>
        {options}
        {options.length > 0 && (
          <ReactTooltip
            id="filteroptiontooltip"
            place="right"
            delayShow={200}
            className="tooltip"
          />
        )}
      </Flex>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/MultiSelectFilter/MultiSelectFilter.tsx